import { createUseStyles } from "$utils/createUseStyles";
import clsx from "clsx";
import { Text } from "$components";
import { theme } from "$utils/theme/bataillog";

type Props = {
  text?: string;
  className?: string;
  colorManual?: string;
  fullWidth?: boolean;
};

function StatusBadge({
  text = "",
  className: cls = "",
  colorManual,
  fullWidth,
}: Props) {
  const classes = useStyles();
  return (
    <span
      className={clsx(classes.badge, cls, fullWidth ? classes.fullWidth : "")}
      style={{
        background: colorManual || "",
      }}
    >
      <Text className={classes.text}>{text}</Text>
    </span>
  );
}

export default StatusBadge;

const useStyles = createUseStyles(() => ({
  fullWidth: {
    width: "100%",
    padding: "5px 0px",
    display: "block",
  },
  badge: {
    padding: "2px",
    borderRadius: "2px",
    textAlign: "center",
  },
  text: {
    color: theme.color.white,
    padding: "0 5px",
  },
}));
